var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "client_profile_page_wrapper" } },
    [
      _c("div", { staticClass: "bb-mobile-header" }, [
        _c(
          "div",
          { staticClass: "bb-mobile-header-left" },
          [
            _c("router-link", { attrs: { to: { name: "clients" } } }, [
              _c("button", { staticClass: "mobile-sidebar-btn" }, [
                _c(
                  "svg",
                  {
                    staticClass: "feather feather-arrow-left",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "22",
                      height: "22",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "#253342",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("line", {
                      attrs: { x1: "19", y1: "12", x2: "5", y2: "12" },
                    }),
                    _c("polyline", { attrs: { points: "12 19 5 12 12 5" } }),
                  ]
                ),
              ]),
            ]),
          ],
          1
        ),
        _c("h1", [_vm._v(_vm._s(_vm.$t("clientProfile.title")))]),
        _c("div", { staticClass: "bb-mobile-header-right" }, [
          _c(
            "button",
            {
              staticClass: "mobile-client-profile-actions-btn",
              on: { click: _vm.showMobileActions },
            },
            [_c("i", { staticClass: "ki ki-more-ver" })]
          ),
        ]),
      ]),
      _vm.client
        ? _c("div", { staticClass: "d-flex client-profile-content" }, [
            _c(
              "div",
              {
                staticClass:
                  "bb-card bb-client-profile-card mr-5 align-self-baseline",
              },
              [
                _c("div", { staticClass: "bb-profile-card-header" }, [
                  _c("div", { staticClass: "bb-badge badge-lg" }, [
                    _vm._v(" " + _vm._s(_vm.client.initials) + " "),
                  ]),
                  _c("p", [_vm._v(_vm._s(_vm.client.fullName))]),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("BBDropdown", {
                      attrs: { positionClass: "left" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "toggle",
                            fn: function () {
                              return [
                                _c(
                                  "button",
                                  { staticClass: "bb-btn btn-lg btn-success" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "clientProfile.createAppointmentDropdown.toggleBtn"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "items",
                            fn: function () {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass: "w-100",
                                    on: {
                                      click: function ($event) {
                                        _vm.createAppointment({
                                          clientId: _vm.client.id,
                                          date: new Date(),
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "clientProfile.createAppointmentDropdown.appointmentBtn"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "w-100",
                                    on: {
                                      click: function ($event) {
                                        _vm.createAppointment({
                                          clientIds: [_vm.client.id],
                                          date: new Date(),
                                          type: "GROUP",
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "clientProfile.createAppointmentDropdown.groupAppointmentBtn"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3672394438
                      ),
                    }),
                    _c("BBDropdown", {
                      staticClass: "client-actions-dropdown",
                      attrs: { positionClass: "right" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "toggle",
                            fn: function () {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "bb-btn btn-lg bb-client-profile-actions-btn",
                                  },
                                  [_c("i", { staticClass: "ki ki-more-ver" })]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "items",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "action-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editClient(_vm.client)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "clientProfile.dropdown.editBtn"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "action-item danger",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteClient()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "clientProfile.dropdown.deleteBtn"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1135021630
                      ),
                    }),
                    _c(
                      "div",
                      { staticClass: "client-profile-contact-buttons" },
                      [
                        _vm.client.phone
                          ? _c(
                              "a",
                              { attrs: { href: "tel:" + _vm.client.phone } },
                              [_c("i", { staticClass: "fas fa-phone-alt" })]
                            )
                          : _vm._e(),
                        _vm.client.email
                          ? _c(
                              "a",
                              { attrs: { href: "mailto:" + _vm.client.email } },
                              [
                                _c("i", {
                                  staticClass:
                                    "flaticon2-black-back-closed-envelope-shape",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "bb-client-profile-card-info" }, [
                  _c("div", { staticClass: "bb-client-profile-info-item" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("clientProfile.infoCard.email.label"))
                      ),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.client.email))]),
                  ]),
                  _c("div", { staticClass: "bb-client-profile-info-item" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("clientProfile.infoCard.phone.label"))
                      ),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.client.phone))]),
                  ]),
                  _c("div", { staticClass: "bb-client-profile-info-item" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("clientProfile.infoCard.notes.label"))
                      ),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.client.notes))]),
                  ]),
                  _c("div", { staticClass: "bb-client-profile-info-item" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("clientProfile.infoCard.notifications.label")
                        )
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.client.notificationsEnabled
                            ? _vm.$t(
                                "clientProfile.infoCard.notifications.enabledLabel"
                              )
                            : _vm.$t(
                                "clientProfile.infoCard.notifications.disabledLabel"
                              )
                        )
                      ),
                    ]),
                  ]),
                  _vm.client.notificationsEnabled == true
                    ? _c(
                        "div",
                        { staticClass: "bb-client-profile-info-item" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "clientProfile.infoCard.notifications.viaLabel"
                                )
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.client.notificationsSentBy == "email"
                                  ? _vm.$t(
                                      "clientProfile.infoCard.notifications.emailLabel"
                                    )
                                  : _vm.$t(
                                      "clientProfile.infoCard.notifications.unknownLabel"
                                    )
                              )
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "bb-client-profile-details-section" },
              [
                _c("div", { staticClass: "bb-card" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "bb-client-profile-sales-icon" },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "29",
                                height: "24",
                                viewBox: "0 0 29 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M26.5694 0.878286C25.1756 0.311943 23.3634 0 21.4668 0C19.5702 0 17.758 0.311943 16.3642 0.878286C15.5405 1.21297 14.9117 1.622 14.5 2.08097C14.0883 1.622 13.4595 1.21303 12.6358 0.878343C11.242 0.311943 9.42981 0 7.5332 0C5.63659 0 3.82443 0.311943 2.43062 0.878286C0.863203 1.5152 0 2.42091 0 3.42857V17.1429C0 18.1505 0.863203 19.0562 2.43062 19.6931C3.72695 20.2199 5.38528 20.5262 7.13672 20.5665V20.5714C7.13672 22.5261 10.3022 24 14.5 24C18.6978 24 21.8633 22.5261 21.8633 20.5714V20.5665C23.6147 20.5262 25.273 20.2199 26.5694 19.6931C28.1368 19.0562 29 18.1505 29 17.1429V3.42857C29 2.42091 28.1368 1.5152 26.5694 0.878286ZM27.8672 13.7143C27.8672 14.2021 27.2077 14.7731 26.1462 15.2045C24.9972 15.6713 23.4547 15.9538 21.8633 15.9943V13.7143C21.8633 13.7126 21.8632 13.711 21.8632 13.7094C23.6147 13.6691 25.273 13.3628 26.5694 12.836C27.0782 12.6293 27.5123 12.3941 27.8672 12.1363L27.8672 13.7143ZM13.9336 6.85714C13.9336 7.34497 13.2741 7.91594 12.2126 8.34731C10.9683 8.85291 9.26278 9.14286 7.5332 9.14286C5.80363 9.14286 4.09806 8.85291 2.85384 8.34731C1.79228 7.91594 1.13281 7.34497 1.13281 6.85714V5.2792C1.48778 5.53691 1.92182 5.77211 2.43062 5.97886C3.82443 6.5452 5.63659 6.85714 7.5332 6.85714C9.42981 6.85714 11.242 6.5452 12.6358 5.97886C13.1446 5.77211 13.5786 5.53691 13.9336 5.2792V6.85714ZM2.43062 9.40743C3.82443 9.97377 5.63659 10.2857 7.5332 10.2857C9.42981 10.2857 11.242 9.97377 12.6358 9.40743C13.1446 9.20069 13.5786 8.96549 13.9336 8.70777V10.2958C12.4683 10.3459 11.063 10.5885 9.92644 10.9923C8.78643 11.3974 7.96611 11.9376 7.52001 12.5713C5.79496 12.5698 4.09489 12.2802 2.85384 11.7759C1.79228 11.3445 1.13281 10.7735 1.13281 10.2857V8.70777C1.48778 8.96549 1.92182 9.20069 2.43062 9.40743ZM1.13281 12.1363C1.48778 12.3941 1.92182 12.6293 2.43062 12.836C3.72701 13.3627 5.38539 13.669 7.13689 13.7094C7.13689 13.711 7.13678 13.7127 7.13678 13.7143V15.9943C5.54534 15.9538 4.00285 15.6713 2.85389 15.2045C1.79228 14.7731 1.13281 14.2021 1.13281 13.7143V12.1363ZM8.32946 13.4335C8.74922 12.448 11.172 11.4286 14.5 11.4286C17.828 11.4286 20.2508 12.448 20.6701 13.4324C20.7108 13.5285 20.7305 13.6206 20.7305 13.7143C20.7305 14.2167 20.1165 14.7747 19.0882 15.207C17.8718 15.7184 16.2423 16 14.5 16C12.7577 16 11.1282 15.7184 9.91183 15.207C8.88346 14.7747 8.26953 14.2167 8.26953 13.7143C8.26953 13.6206 8.2893 13.5285 8.32946 13.4335ZM27.8672 10.2857C27.8672 10.7735 27.2077 11.3445 26.1462 11.7759C24.9052 12.2802 23.2052 12.5698 21.4802 12.5713C21.0344 11.9379 20.214 11.3975 19.0736 10.9923C17.937 10.5885 16.5317 10.3459 15.0664 10.2958V8.70777C15.4214 8.96549 15.8554 9.20069 16.3642 9.40743C17.758 9.97377 19.5702 10.2857 21.4668 10.2857C23.3634 10.2857 25.1756 9.97377 26.5694 9.40743C27.0782 9.20069 27.5122 8.96549 27.8672 8.70777V10.2857ZM27.8672 6.85714C27.8672 7.34497 27.2077 7.91594 26.1462 8.34731C24.9019 8.85291 23.1964 9.14286 21.4668 9.14286C19.7372 9.14286 18.0317 8.85291 16.7874 8.34731C15.7259 7.91594 15.0664 7.34497 15.0664 6.85714V5.2792C15.4214 5.53691 15.8554 5.77211 16.3642 5.97886C17.758 6.5452 19.5702 6.85714 21.4668 6.85714C23.3634 6.85714 25.1756 6.5452 26.5694 5.97886C27.0782 5.77211 27.5122 5.53691 27.8672 5.2792V6.85714ZM16.7874 1.9384C18.0317 1.4328 19.7372 1.14286 21.4668 1.14286C23.1964 1.14286 24.9019 1.4328 26.1462 1.9384C27.2077 2.36977 27.8672 2.94074 27.8672 3.42857C27.8672 3.9164 27.2077 4.48737 26.1462 4.91874C24.9019 5.42434 23.1964 5.71429 21.4668 5.71429C19.7372 5.71429 18.0317 5.42434 16.7874 4.91874C15.7259 4.48737 15.0664 3.9164 15.0664 3.42857C15.0664 2.94074 15.7259 2.36977 16.7874 1.9384ZM2.85384 1.9384C4.09806 1.4328 5.80363 1.14286 7.5332 1.14286C9.26278 1.14286 10.9683 1.4328 12.2126 1.9384C13.2741 2.36977 13.9336 2.94074 13.9336 3.42857C13.9336 3.9164 13.2741 4.48737 12.2126 4.91874C10.9683 5.42434 9.26278 5.71429 7.5332 5.71429C5.80363 5.71429 4.09806 5.42434 2.85384 4.91874C1.79228 4.48737 1.13281 3.9164 1.13281 3.42857C1.13281 2.94074 1.79228 2.36977 2.85384 1.9384ZM2.85384 18.633C1.79228 18.2017 1.13281 17.6307 1.13281 17.1429V15.5649C1.48778 15.8226 1.92182 16.0578 2.43062 16.2646C3.72695 16.7913 5.38528 17.0976 7.13672 17.1379V19.423C5.54529 19.3823 4.00279 19.0999 2.85384 18.633ZM19.0882 22.0642C17.8718 22.5755 16.2423 22.8571 14.5 22.8571C12.7577 22.8571 11.1282 22.5755 9.91183 22.0642C8.88346 21.6319 8.26953 21.0738 8.26953 20.5714V19.0268C8.39782 19.1205 8.53959 19.2135 8.69683 19.3053C9.5764 19.8188 10.7732 20.1986 12.1578 20.4037C12.1857 20.4078 12.2134 20.4098 12.2408 20.4098C12.5172 20.4098 12.7591 20.2054 12.8004 19.9213C12.8459 19.609 12.6318 19.3187 12.3223 19.2729C9.68996 18.883 8.26953 17.8845 8.26953 17.1429V15.5931C9.55154 16.5395 11.8145 17.1429 14.5 17.1429C17.1855 17.1429 19.4485 16.5395 20.7305 15.5931V17.1429C20.7305 17.8845 19.31 18.883 16.6777 19.2729C16.3682 19.3187 16.1541 19.609 16.1996 19.9213C16.2409 20.2054 16.4828 20.4098 16.7592 20.4098C16.7866 20.4098 16.8143 20.4078 16.8422 20.4037C18.2268 20.1986 19.4235 19.8189 20.3032 19.3053C20.4604 19.2135 20.6022 19.1205 20.7305 19.0268V20.5714C20.7305 21.0738 20.1165 21.6319 19.0882 22.0642ZM26.1462 18.633C24.9972 19.0999 23.4547 19.3823 21.8633 19.4229V17.1379C23.6147 17.0975 25.273 16.7913 26.5694 16.2645C27.0782 16.0578 27.5122 15.8226 27.8672 15.5649V17.1429C27.8672 17.6307 27.2077 18.2017 26.1462 18.633Z",
                                  fill: "white",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "bb-client-profile-total-sales" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("clientProfile.salesCard.title"))
                            ),
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.totalSales) + " RSD")]),
                        ]
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center mb-3 mt-3",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "bb-card bb-client-bookings-card" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("clientProfile.salesCard.bookings.all")
                            )
                          ),
                        ]),
                        _c("span", [_vm._v(_vm._s(_vm.allBookingsCount))]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "bb-card bb-client-bookings-card success",
                      },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "clientProfile.salesCard.bookings.completed"
                              )
                            )
                          ),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.completedBookingsCount)),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "bb-card bb-client-bookings-card danger" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "clientProfile.salesCard.bookings.canceled"
                              )
                            )
                          ),
                        ]),
                        _c("span", [_vm._v(_vm._s(_vm.canceledBookingsCount))]),
                      ]
                    ),
                  ]
                ),
                _c("AppointmentsList", {
                  attrs: {
                    client: _vm.client,
                    paginationDisabled: _vm.appointmentsPaginationDisabled,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mobileActionsVisible,
              expression: "mobileActionsVisible",
            },
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.handleMobileActionsOutsideClick,
              expression: "handleMobileActionsOutsideClick",
            },
          ],
          staticClass: "mobile-client-actions-container",
        },
        [
          _c("div", { staticClass: "mobile-client-actions" }, [
            _c(
              "button",
              {
                staticClass: "mobile-client-action-btn",
                on: {
                  click: function ($event) {
                    _vm.editClient(_vm.client)
                    _vm.hideMobileActions()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("clientProfile.mobileButtons.editBtn")) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "mobile-client-action-btn danger",
                on: {
                  click: function ($event) {
                    _vm.deleteClient()
                    _vm.hideMobileActions()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("clientProfile.mobileButtons.deleteBtn")) +
                    " "
                ),
              ]
            ),
          ]),
          _c(
            "button",
            {
              staticClass: "mobile-client-action-btn",
              on: { click: _vm.hideMobileActions },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("clientProfile.mobileButtons.closeBtn")) +
                  " "
              ),
            ]
          ),
        ]
      ),
      _c("ClientFormModal", {
        ref: "clientFormModal",
        on: { clientUpdated: _vm.fetchClient },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }